export default __webpack_public_path__ + "static/media/cardRegisterDeposit.d69b5de3.png";